// DEPENDENCIES
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline'

// COMPONENTS
import { MapTopBarMobileContainer } from './Main/MapTopBarMobile';
import { MugicsMapContainer } from './Main/MugicsMap';
import { MapBottomBarContainer } from './Main/MapBottomBar';
import MapBandFinderBottomBar from './Main/MapBandFinderBottomBar';
import { About } from './Main/About';
import { Footer } from './Footer';
import Mosaic from './Main/Mosaic';
import { Contact } from './Modals/Contact';
import { PinFullViewModalWeb, PinFullViewModalMobile } from './ModalsNew';

import { isMobile } from '../utils';

// actions
import * as actions from '../Actions/main';
import {
    openSubmitModalRequest,
    openParticipateModal,
    loginTemp,
    getUserLocation
} from '../Actions/users';
import { closePinFullViewModal, openPinFullViewModal } from '../Actions/modals';

// consts
import { MOBILE_MODE_GALLERY } from '../consts';

// svgs
import mapLocationSVG from './inlineSVGs/mapLocationSVG';
import listingOptionsSVG from './inlineSVGs/listingOptionsSVG';

// styles
import './Main.css';
import {PinCounterAnimated} from "./Elements/PinCounters";
import {clientMedia} from "../Config/Settings";

const TOP_SCROLL_TRIGGER = 38;
const COUNTRY_COUNT_ANIMATION_TRIGGER = 300; // scroll Y

class Main extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isStickyBar: false,
            isCountAnimation: false
        }
    }

    // happens after the component is rendered
    componentDidMount() {
        // check for html5 location permission if decline use IP service
        this.props.getUserLocation();

        // executing getPinsCall action, to get all pins after component is loaded
        // this.props.getPinsCall(this.props.filters);

        // Setting the location of the map according to the use location based on his ip
        if (this.props.location.query.userid && !this.props.isLoggedIn) {
            this.props.loginTemp(this.props.location.query.userid);
        }

        this.props.getDatatypes();

        // getting and poping up shared ad
        if (this.props.location.query.sid) {
            // TODO: create request for the server to get the shared pin ad
            this.props.getSharedPin(this.props.location.query.sid);
        }

        this.setState({ isStickyBar: !this.props.isMobileFilterBar })
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userLocation && !this.props.userLocation) {

            nextProps.changeLocationOnMap(nextProps.userLocation.latitude, nextProps.userLocation.longitude);
        }

        if (nextProps.isMobileFilterBar !== this.props.isMobileFilterBar) {
            this.setState({ isStickyBar: this.props.isMobileFilterBar })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll.bind(this));
    }

    handleScroll() {
        if (!window) return;

        if (!this.state.isCountAnimation && window.scrollY > COUNTRY_COUNT_ANIMATION_TRIGGER) {
            this.setState({ isCountAnimation: true });
        }

        // if (isMobile() && !this.props.isMobileFilterBar) {
        //     if (!this.state.isStickyBar) return this.setState({ isStickyBar: true });
        //     return;
        // }

        if (window.scrollY < TOP_SCROLL_TRIGGER && this.state.isStickyBar && this.props.isMobileFilterBar) {
            this.setState({isStickyBar: false});
            return;
        }

        if ((window.scrollY > TOP_SCROLL_TRIGGER && !this.state.isStickyBar)) this.setState({ isStickyBar: true })
    }

    paginationHandler(pageId) {
        if (!pageId) {
            pageId = 0;
        }

        // this.props.filters.pageNumber = pageId - 1;
    }

    changeType(value) {
        this.props.resetFiltersType(value);

        // scroll to map
        window.scrollTo(0, 338)
    }

    renderMapBar() {
        if (isMobile()) return null;

        const barType = this.props.filters && this.props.filters.type;

        return <div style={{minHeight: 5, padding: 0}} className={`web-map-bar ${barType} top`}></div>
    }

    renderMobileFilterBar() {
        if (isMobile()) return <MapTopBarMobileContainer filters={this.props.filters} isStickyBar={this.state.isStickyBar}/>;
    }


    renderMobileBanner() {
        if (!isMobile() || this.props.mode === 'map') return null;

        if (!this.props.datatypes ||
            !this.props.datatypes.banner ||
            !this.props.datatypes.banner.mobile ||
            !this.props.datatypes.banner.mobile[this.props.filters.type]
        ) return null;

        return (
            <div className={`mobile-banner-wrapper ${this.props.filters.type}`}>
                <img
                    style={{width: window.innerWidth, height: 'auto'}}
                    src={`${clientMedia()}/img/bannerImages/banner-mobile-${this.props.filters.type}.jpg`}
                    alt="banner-mobile"
                />
            </div>
        )
    }

    renderMapButton() {
        if (isMobile()) return null;

        return (
            <div className={`modeButton ${this.props.filters && this.props.filters.type}`} onClick={() => this.props.toggleMode()}>
                {this.props.mode === 'map' ?
                    <SVGInline svg={listingOptionsSVG} className="toggle-map-icon" component="i"/>
                    :
                    <SVGInline svg={mapLocationSVG} className="toggle-map-icon" component="i"/>
                }
            </div>
        )
    }

    renderMapArea() {
        return (
            <div className={`map-area`}>
                {this.renderMapBar()}
                <MugicsMapContainer
                    currentLocation={this.props.currentLocation}
                    groupedPins={this.props.mapPins || []}
                    filters={this.props.filters}
                    mode={this.props.mode}
                />
            </div>
        )
    }

    renderMosaicArea() {
        return (
            <Mosaic paginationHandler={this.paginationHandler.bind(this)}/>
        )
    }

    renderMainWebContent() {
        return (
            <div className={`map-pins-wrapper ${this.props.isMapTop ? 'map-top' : ''}`}>
                {this.renderMapArea()}
                {this.renderMosaicArea()}
            </div>
        )
    }

    render() {
        if (!this.props || !this.props.datatypes) return null;

        return (
            <div className={`Main ${this.state.isStickyBar ? 'sticky-bar-wrapper' : ''}`} id="main-page-map">
                <MapBottomBarContainer/>
                {/*{this.props.mode === MOBILE_MODE_MAP && <MapBandFinderBottomBar filters={this.props.filters}/>}*/}
                {isMobile() ? null : <MapBandFinderBottomBar filters={this.props.filters || {}} isGalleryMode={this.props.mode === MOBILE_MODE_GALLERY}/>}

                {this.renderMobileFilterBar()}

                {this.renderMobileBanner()}
                {!isMobile() ?
                    <PinCounterAnimated
                        type={this.props.filters.type}
                        defaults={this.props.datatypes.defaults}
                        countryPinCount={this.props.countryPinCount || {}}
                        chosenDateLabel={this.props.chosenDateLabel || 'soon'}
                        startCountAnimation={this.state.isCountAnimation}
                    /> : null
                }

                {!isMobile() ? this.renderMainWebContent() : null}

                {isMobile() ? this.renderMapArea() : null}
                {isMobile() ? this.renderMosaicArea() : null}

                {this.renderMapButton()}
                <About isHideJoin onPress={this.props.openParticipateModal} openContact={this.props.openContactModal} />
                <Footer
                    isShowFooter={!isMobile()}
                    onPress={this.props.openParticipateModal}
                    openContact={this.props.openContactModal}
                    filterChange={this.changeType.bind(this)}
                    datatypes={this.props.datatypes}
                />
                <Contact
                    isModalOpen={this.props.isContactModalOpen}
                    closeModal={this.props.closeContactModal}
                />
                {isMobile() ?
                    <MapBandFinderBottomBar filters={this.props.filters || {}} isGalleryMode={this.props.mode === MOBILE_MODE_GALLERY}/>
                    : null
                }
                {isMobile() ?
                    <PinFullViewModalMobile
                        isModalOpen={this.props.isPinFullViewModalOpen}
                        closeModal={this.props.closePinFullViewModal}
                    />
                    :
                    <PinFullViewModalWeb
                        isModalOpen={this.props.isPinFullViewModalOpen}
                        modalType={this.props.modalType}
                        closeModal={this.props.closePinFullViewModal}
                        datatypes={this.props.datatypes}
                    />
                }
            </div>
        );
    }
}

Main.propTypes = {
    openContactModal: PropTypes.func,
    closeContactModal: PropTypes.func,
    openParticipateModal: PropTypes.func,
    openSubmitModalRequest: PropTypes.func,
    openPinModal: PropTypes.func,
    openPinFullViewModal: PropTypes.func,
    openBandFinderPinModal: PropTypes.func,
    openPayingMethodsModal: PropTypes.func,
    closePayingMethodsModal: PropTypes.func,
    addMorePins: PropTypes.func,
    mode: PropTypes.string,
    isContactModalOpen: PropTypes.bool,
    //pins: PropTypes.array,
    pinsNew: PropTypes.array,
    mapPins: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    pages: PropTypes.number,
    filters: PropTypes.object,
    getPinsCall: PropTypes.func,
    datatypes: PropTypes.object,
    updateFilters: PropTypes.func,
    resetFiltersType: PropTypes.func,
    removeFilter: PropTypes.func,
    route: PropTypes.string,
    isMapTop: PropTypes.bool,
    chosenDateLabel: PropTypes.string,
    countryPinCount: PropTypes.object,

    // modal controllers
    isPinFullViewModalOpen: PropTypes.bool,
    closePinFullViewModal: PropTypes.func,
    modalType: PropTypes.string,
    isMobileFilterBar: PropTypes.bool
};

const mapStateToProps = state => ({
    //pins: state.main.pins,
    mapPins: state.main.mapPins,
    pinsNew: state.main.pinsNew,
    pages: state.main.pages,
    filters: state.main.filters,
    currentLocation: state.main.currentLocation,
    isLoggedIn: state.users.isLoggedIn,
    mode: state.main.mode,
    datatypes: state.main.datatypes,
    isContactModalOpen: state.main.isContactModalOpen,
    route: state.routing.locationBeforeTransitions.pathname,
    userLocation: state.users.userLocation,
    isMapTop: state.main.isMapTop,
    chosenDateLabel: state.main.chosenDateLabel,
    countryPinCount: state.main.countryPinCount,

    // modal controllers
    isPinFullViewModalOpen: state.modals.isPinFullViewModalOpen,
    modalType: state.modals.modalType,
    isMobileFilterBar: state.main.isMobileFilterBar
});

// connecting redux state to the component props
export const MainContainer = connect(mapStateToProps, {...actions,
    loginTemp,
    openSubmitModalRequest,
    openParticipateModal,
    getUserLocation,
    closePinFullViewModal,
    openPinFullViewModal
})(Main);

export default Main;




// WEBPACK FOOTER //
// ./src/Components/Main.js